<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="fabricStockOutCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <el-image
          :src="
            row.imageCode
              ? $osscdn(row.imageCode)
              : '/image/static/img/nopic.jpg'
          "
          style="width: 100px; height: 66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.fabricStockOutStatus === 'Y'
              ? 'success'
              : row.fabricStockOutStatus === 'A'
              ? 'info'
              : row.fabricStockOutStatus === 'P'
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.fabricStockOutStatusName }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="formLoad('detail', row.fabricStockOutCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="formLoad('edit', row.fabricStockOutCode)"
              v-show="
                row.fabricStockOutStatus === 'N' ||
                  row.fabricStockOutStatus === 'B'
              "
              v-if="allow('M')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="update(row.fabricStockOutCode, 'D')"
              v-show="
                row.fabricStockOutStatus === 'N' ||
                  row.fabricStockOutStatus === 'B'
              "
              v-if="allow('D')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
          >
            <i
              class="el-icon-s-check tool-btn"
              @click="submitReview(row.fabricStockOutCode)"
              v-show="
                row.fabricStockOutStatus === 'N' ||
                  row.fabricStockOutStatus === 'B'
              "
              v-if="allow('C')"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_confirmation') || '出库确认'"
            placement="top"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="deliveryConfirmation(row.fabricStockOutCode)"
              v-show="row.fabricStockOutStatus === 'A'"
              v-if="allow('C')"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: {
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: this.reload,
        },
        zoom: true,
      },
      tableColumn: [
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 200,
          fixed: 'right',
          slots: {
            default: 'opt',
          },
        },
        // { width: 50, fixed: 'left', type: this.single ? 'radio' : 'checkbox' },
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
        },
        {
          field: 'fabricStockOutNo',
          width: 145,
          title: this.$l('label_odd_numbers') || '面料出库单号',
        },
        {
          field: 'fabricStockOutStatus',
          minWidth: 80,
          title: this.$l('label_demand_status') || '状态',
          align: 'center',
          slots: { default: 'status' },
        },
        {
          field: 'requestAgentName',
          minWidth: 110,
          title: this.$l('label_applicant') || '申请人',
        },
        {
          field: 'requestDate',
          minWidth: 110,
          title: this.$l('label_date_application') || '申请日期',
        },
        {
          field: 'outStockDate',
          minWidth: 110,
          title: this.$l('label_delivery_date') || '出库日期',
        },
        {
          field: 'createInfo',
          width: 170,
          title: 'Create',
          slots: { default: 'createInfo' },
        },
        {
          field: 'modifyInfo',
          width: 170,
          title: 'Modify',
          slots: { default: 'modifyInfo' },
        },
      ],
    }
  },
  methods: {
    reload() {
      this.$emit('submit')
    },
    // 加载表单
    formLoad(ref, val = '') {
      // if ('add' === ref) {
      //   this.add()
      // } else {
      let params = {
        pageType: ref,
        fabricStockOutCode: val,
      }
      this.$router.push({
        name: 'master-fabricStockOutDetail',
        params: params,
      })
      // }
    },
    // add() {
    //   this.$api.fabricStockOutSaveApi().then((res) => {
    //     let params = {
    //       pageType: 'edit',
    //       fabricStockOutCode: res.body,
    //     }
    //     this.$router.push({
    //       name: 'master-fabricStockOutDetail',
    //       params: params,
    //     })
    //   })
    // },
    update(code) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .fabricStockOutdDelApi({
            fabricStockOutCode: code,
          })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!'
            )
            this.$emit('submit')
          })
      })
    },
    deliveryConfirmation(val) {
      let msg = this.$l('INDEX.tips_delivery_confirmation') || '是否确认出库?'
      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.btn_tips_audit') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .fabricStockOutDeliveryConfirmation({
            fabricStockOutCode: val,
          })
          .then(() => {
            this.$message.success(
              this.$l('INDEX.tips_operate_ok') || '操作成功!'
            )
            this.$emit('submit')
          })
      })
    },
    submitReview(val) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核?',
        this.$l('INDEX.tips_question_title') || '提示',
        {
          confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .fabricStockOutdAuditApi({
            fabricStockOutCode: val,
          })
          .then((res) => {
            if (res.status === 200 && res.msg != '检查审核成功') {
              this.$confirm(res.msg, '面料出库数量超出库存数量', {
                confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
                cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
              })
              return
            }
            this.$api
              .fabricStockOutOaStockOutApply({
                fabricStockOutCode: val,
                linkUrl: this.$joinURL(`/opview/fabricstockout/${val}`, {
                  joinOrigin: true,
                  joinBasePath: false,
                }),
              })
              .then(() => {
                this.$message.success(
                  this.$l('INDEX.tips_Submitted_successfully') || '提交成功!'
                )
                this.$emit('submit')
              })
          })
      })
    },
  },
}
</script>
